import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const serpApi = defineConnector({
  identifier: "serpApi",
  name: "SerpApi",
  tagLine: "Search engine results APIs",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://serpapi\\.com/.*",
  auth: (app) => queryAuth([{ name: "api_key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Find your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Open your [SerpApi account settings](https://serpapi.com/manage-api-key) and copy the private API key. SerpApi expects it in the `api_key` query parameter for account and search endpoints.",
        },
      ],
    },
    {
      title: "Enter your SerpApi key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://serpapi.com/account.json",
  },
});
